import Vue from 'vue';
import { apiPath } from '@/api/constants';

const AppApiAgents = Vue.resource(
  `${apiPath}/apps{/packageName}/api-agents{/apiAgentId}{/action}/`,
  {},
  {
    regenerateToken: {
      method: 'POST',
      params: { action: 'regenerate-token' },
    },
  },
  {
    transformToCamelCase: true,
  },
);

export default AppApiAgents;
